import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import propsTypes from "prop-types";
import { Row, Col } from "./style";

const VerifyCode = ({
  name,
  className,
  autoComplete,
  disabled,
  onChange,
  theme,
}) => {
  const inputOneRef = useRef();
  const inputTwoRef = useRef();
  const inputTreeRef = useRef();
  const inputForRef = useRef();

  const [state, setState] = useState({
    inputOne: "",
    inputTwo: "",
    inputTree: "",
    inputFor: "",
  });

  const handleChangeOne = (e) => {
    setState({
      ...state,
      inputOne: e.target.value,
    });

    if (e.target.value) {
      inputTwoRef.current.focus();
    }
  };

  const handleChangeTow = (e) => {
    setState({
      ...state,
      inputTwo: e.target.value,
    });

    if (e.target.value) {
      inputTreeRef.current.focus();
    } else {
      inputOneRef.current.focus();
    }
  };

  const handleChangeTree = (e) => {
    setState({
      ...state,
      inputTree: e.target.value,
    });

    if (e.target.value) {
      inputForRef.current.focus();
    } else {
      inputTwoRef.current.focus();
    }
  };

  const handleChangeFor = (e) => {
    setState({
      ...state,
      inputFor: e.target.value,
    });

    if (e.target.value) {
      onChange(
        name,
        `${state.inputOne}${state.inputTwo}${state.inputTree}${e.target.value}`
      );
    } else {
      inputTreeRef.current.focus();
    }
  };

  useEffect(() => {
    inputOneRef.current.focus();
  }, []);

  return (
    <>
      <Row className="row px-2 mb-4 direaction-ltr">
        <Col className="col-3">
          <input
            ref={inputOneRef}
            className={`input-verfy ${
              theme?.isDarkTheme && "dark"
            } ${className}`}
            value={state.inputOne}
            onChange={handleChangeOne}
            maxLength="1"
            type="tel"
            autoComplete={autoComplete}
            disabled={disabled}
          />
        </Col>
        <Col className="col-3">
          <input
            ref={inputTwoRef}
            className={`input-verfy ${
              theme?.isDarkTheme && "dark"
            } ${className}`}
            value={state.inputTwo}
            onChange={handleChangeTow}
            maxLength="1"
            type="tel"
            autoComplete={autoComplete}
            disabled={disabled}
          />
        </Col>
        <Col className="col-3">
          <input
            ref={inputTreeRef}
            className={`input-verfy ${
              theme?.isDarkTheme && "dark"
            } ${className}`}
            value={state.inputTree}
            onChange={handleChangeTree}
            maxLength="1"
            type="tel"
            autoComplete={autoComplete}
            disabled={disabled}
          />
        </Col>
        <Col className="col-3">
          <input
            ref={inputForRef}
            className={`input-verfy ${
              theme?.isDarkTheme && "dark"
            } ${className}`}
            value={state.inputFor}
            onChange={handleChangeFor}
            maxLength="1"
            type="tel"
            autoComplete={autoComplete}
            disabled={disabled}
          />
        </Col>
      </Row>
    </>
  );
};

VerifyCode.propsTypes = {
  name: propsTypes.string,
  className: propsTypes.string,
  autoComplete: propsTypes.string,
  disabled: propsTypes.bool,
  onChange: propsTypes.func,
};

VerifyCode.defaultProps = {
  disabled: false,
  autoComplete: "off",
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(VerifyCode);
